<template>
  <v-app>
    <v-toolbar
      v-show="showCatalogScreen"
      class="fixed-bar"
      flat
      dense
      :color="`${conf.interface_description.first_screen.toolbar}`"
    >
      <v-spacer />
      <v-badge
        v-if="totalEntity>0"
        color="success"
        overlap
        :content="totalEntity"
      >
        <v-icon @click="onShowCartScreen">
          mdi-cart-outline
        </v-icon>
      </v-badge>
      <v-icon v-else>
        mdi-cart-outline
      </v-icon>
    </v-toolbar>
    <v-container fluid>
      <v-row>
        <v-col>
          <configuration-catalog-screen
            v-show="showCatalogScreen"
            :cart="cart"
            :catalog="catalogPage"
            :catalog-screen="catalogScreen"
            :screen="conf.interface_description.first_screen"
            @cart="onShowCartScreen"
            @change="onChangeCart"
          />
          <configuration-cart-screen
            v-show="showCartScreen"
            :cart="cart"
            @change="onChangeCartItem"
            @delete="onDeleteCartItem"
            @pay="onPay"
            @shop="showCatalogScreen=showScreen(); $forceUpdate()"
          />
          <configuration-error-screen
            v-if="showErrorScreen"
            :screen="conf.interface_description.error_screen"
          />
          <configuration-final-screen
            v-if="showFinalScreen"
            :cheque="cheque"
            :screen="conf.interface_description.final_screen"
            @showCheque="onCheque"
          />
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-overlay>
    </v-container>
    <v-row>
      <v-dialog
        v-model="showPaymentScreen"
        fullscreen
        hide-overlay
      >
        <v-card>
          <v-toolbar
            flat
            dense
            class="red--text d-flex flex-wrap"
          >
            <v-btn
              small
              icon
              @click="onClosePaymentScreen"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <span class="text-center">После оплаты возвратитесь в текущее окно, для продолжении работы</span>
          </v-toolbar>
          <iframe
            :src="nspkLink"
            width="100%"
            height="100%"
          />
        </v-card>
      </v-dialog>
    </v-row>
  </v-app>
</template>
<script>

import ConfigurationCatalogScreen
  from "@/views/loyalty/shared/components/justpay-configuration/ConfigurationCatalogScreen.vue"
import { MqttDingtianService } from "@/views/loyalty/shared/services/mqtt-dingtian-service"
import { JustpayPaymentMqttService } from "@/views/loyalty/shared/services/justpay-paymentmqtt-service"
import { JustpayPaymentSystemService } from "@/views/loyalty/shared/services/justpay-paymentsystem-service"
import ConfigurationCartScreen
  from "@/views/loyalty/shared/components/justpay-configuration/ConfigurationCartScreen.vue"
import ConfigurationErrorScreen
  from "@/views/loyalty/shared/components/justpay-configuration/ConfigurationErrorScreen.vue"
import { guid, setScreenBackground } from "@/views/loyalty/shared/modules/utilities"
import { SbpStateEnum } from "@/views/loyalty/models/justpay-sbp.model"
import ConfigurationFinalScreen
  from "@/views/loyalty/shared/components/justpay-configuration/ConfigurationFinalScreen.vue"
import { configuration, ConfigurationPosTypeEnum } from "@/views/loyalty/models/justpay-configuration.model"
import { addSeconds, differenceInSeconds } from "date-fns"

export default {
  components: { ConfigurationFinalScreen, ConfigurationErrorScreen, ConfigurationCartScreen, ConfigurationCatalogScreen },
  data: () => ({
    cart: [], // [{amount:1, cost:1, nomenclatureId:"", nomenclatureName:"",price:1,relayNumber:"",scenario:"",tax:1}]
    catalogPage: {},
    catalogScreen: {},
    cheque: null,
    conf: configuration,
    guid: null,
    mqttDingtianService: null,
    nspkLink: null,
    overlay: false,
    paymentId: null,
    paymentMqttService: null,
    paymentSystemService: null,
    pointId: null,
    sbpId: null,
    showCartScreen: false,
    showCatalogScreen: false,
    showErrorScreen: false,
    showFinalScreen: false,
    showPaymentScreen: false,
    startDate: null,
    timeoutSbp: 0
  }),
  computed: {
    totalEntity () {
      return this.cart.reduce((acc, c) => acc + c.amount, 0)
    },
    totalSum () {
      return this.cart.reduce((acc, c) => acc + c.cost, 0)
    }
  },
  watch: {
    showCatalogScreen (newVal) {
      if (newVal) {
        setScreenBackground(this.conf.interface_description.first_screen.background)
      }
    }
  },
  async beforeMount () {
    this.mqttDingtianService = new MqttDingtianService()
    this.paymentMqttService = new JustpayPaymentMqttService()
    this.paymentSystemService = new JustpayPaymentSystemService()
    this.pointId = this.$route.query.id
    this.$store.state.pointId = this.pointId
    const response = await this.paymentMqttService.getConfPos(this.pointId)
    console.log('response', response)
    console.log('response.configuration', response.configuration)
    console.log('catalogScreen', response.configuration.pos.pages.find(page => page.type === ConfigurationPosTypeEnum.Information).screen)
    if (response.configuration) {
      this.conf = response.configuration
      this.catalogPage = response.configuration.pos.pages.find(page => page.type === ConfigurationPosTypeEnum.Catalog)
      this.catalogScreen = response.configuration.pos.pages.find(page => page.type === ConfigurationPosTypeEnum.Information).screen
      console.log('catalogPage', this.catalogPage)
      this.catalogPage.nomenclatures.forEach(nomenclature => {
        Object.defineProperty(nomenclature, 'amount', { value: 1, writable: true })
      })
      this.showCatalogScreen = this.showScreen()
      console.log('new catalogPage', this.catalogPage)
      this.timeoutSbp = await this.paymentMqttService.getTimeout() // the data is taken from server configuration
      // this.timeoutSbp = 10 // for testing
    }
  },
  mounted () {
    this.guid = guid()
  },
  methods: {
    getDataForSendingToRelay () {
      const dataArray = []
      this.cart.forEach(c => {
        const scenario = this.conf.releScenarios.find(rs => c.scenario === rs.scenarioId)
        console.log('getDataForSendingToRelay scenario', scenario)
        if (scenario) {
          scenario.releConf.pages.forEach(page => {
            page.actions.forEach(action => {
              dataArray.push({
                command: action.command.type, // number of command
                number: c.relayNumber,
                relayIndex: action.command.number,
                repeats: { number: c.amount, beforeTimeout: action.before_timeout, afterTimeout: action.after_timeout },
                timeout: action.command.time
              })
            })
          })
      }
      })
      console.log('getDataForSendingToRelay dataArray', dataArray)
      return dataArray
    },
    async onCheque () {
      this.cheque = await this.paymentSystemService.getCheque(this.paymentId)
    },
    onClosePaymentScreen () {
      this.showErrorScreen = this.showScreen()
    },
    onChangeCart (cart) {
      console.log('onChangeCart cart', cart)
      this.cart = cart
    },
    onChangeCartItem (item) {
      console.log('onChangeCartItem item', item)
      this.catalogPage.nomenclatures.forEach(nomenclature => {
        if (nomenclature.id === item.nomenclatureId) {
          nomenclature.amount = item.amount
        }
      })
      console.log('onChangeCartItem this.catalogPage', this.catalogPage)
      this.catalogPage = Object.assign({}, this.catalogPage)
    },
    onDeleteCartItem (cart, item) {
      console.log('onDeleteCartItem item', item)
      this.catalogPage.nomenclatures.forEach(nomenclature => {
        if (nomenclature.id === item.nomenclatureId) {
          nomenclature.amount = 1
        }
      })
      console.log('onDeleteCartItem this.catalogPage', this.catalogPage)
      console.log('onDeleteCartItem cart', cart)
      this.catalogPage = Object.assign({}, this.catalogPage)
      this.cart = cart
    },
    async onPay () {
      console.log("onPay cart", this.cart)
      const items = this.cart.map(m => {
        return { amount: m.cost, count: m.amount, name: m.nomenclatureName, price: m.price, nomenclatureId: m.nomenclatureId, nomenclatureTax: m.tax }
      })
      const payment = { idempotency: this.guid, pointId: this.pointId, resultPage: 3, sum: this.totalSum, items: items }
      console.log("onPay payment", payment)
      this.overlay = true // show progress circular
      // const response = { value: { error: false } } // for testing
      const response = await this.paymentSystemService.createPayment(payment) // resultPage = 3 (ResultPageEnum.QrRelayPay)
      console.log("onPay response", response)
      this.overlay = false
      if (!response.value.error) {
        console.log("!!!!")
        this.nspkLink = response.value.data.qr
        this.sbpId = response.value.data.sbp
        this.paymentId = response.value.data.paymentId
        // this.sbpId = 0 // for testing

        await this.paymentMqttService.sendMessage({ isRepeat: this.conf.repeatsRelay, relayRequests: this.getDataForSendingToRelay(), sbpId: this.sbpId, timeout: this.timeoutSbp })
        this.showPaymentScreen = this.showScreen()
        this.startDate = new Date()

        while (differenceInSeconds(addSeconds(this.startDate, this.timeoutSbp), new Date()) > 0 && this.sbpState !== SbpStateEnum.Paid) {
          await this.startScanSbpState(this.sbpId)
          await this.mqttDingtianService.sleep(2)
            // console.log('*** this.sbpState', this.sbpState)
        }
        this.stopScanSbpState(this.timerId)
      }
    },
    onShowCatalogScreen () {
      this.showCatalogScreen = this.showScreen()
    },
    onShowCartScreen (cart) {
      this.showCartScreen = this.showScreen()
      console.log('showScreen this.showCartScreen', this.showCartScreen)
    },
    showScreen () {
      this.showCartScreen = false
      this.showCatalogScreen = false
      this.showErrorScreen = false
      this.showErrorScreen = false
      this.showFinalScreen = false
      this.showPaymentScreen = false
      return true
    },
    async startScanSbpState (sbpId) {
      this.sbpState = await this.paymentMqttService.getSbpState(sbpId)
      // this.sbpState = SbpStateEnum.Paid // for testing
      console.log('sbpState', this.sbpState)
      if (this.sbpState === SbpStateEnum.Paid) {
        this.showFinalScreen = this.showScreen()
        // this.conf.repeatsRelay
        // ? this.mqttDingtianService.sendMessageFromCartRepeat(this.getDataForSendingToRelay())
        //     : this.mqttDingtianService.sendMessageFromCart(this.getDataForSendingToRelay())
      }
    },
    stopScanSbpState (timerId) {
      console.log('stopScanSbpState')
      if (this.sbpState === SbpStateEnum.Paid) {
        this.showFinalScreen = this.showScreen()
      } else {
        this.showErrorScreen = this.showScreen()
      }
    },
  }
}
</script>

<style scoped>
.fixed-bar {
  position: sticky;
  top: 0px;
  z-index: 2;
}
</style>
